<template>
  <b-row>
    <b-col cols="12">
      <b-card>
        <!-- <b-card-body> -->
        <data-table
          ref="tableManageCampaign"
          :data-table="dataCampaignItem"
          :field-table="dataCampaignField"
          :status="dataCampaignStatus"
          :table-for="table"
          :data-for="dataFor"
          :mutation-for="mutationFor"
          :list="list"
          :action="action"
        >
          <template #head(checkbox)="data">
            <b-form-checkbox
              :key="data.key"
              v-model="checkAll"
              @input="selectAll"
            />
          </template>
          <template #cell(checkbox)="data">
            <b-form-checkbox
              :checked="data.rowSelected"
              disabled
            />
          </template>
          <template #cell(start_date)="data">
            {{ formatDateIdr(data.value) }}
          </template>
          <template #cell(end_date)="data">
            {{ formatDateIdr(data.value) }}
          </template>
          <template #cell(budget)="data">
            {{ formatPrice(data.value) }}
          </template>
          <template
            #cell(actions)="data"
          >
            <b-button
              variant="outline-primary"
              size="sm"
              @click="viewDetail(data.item.campaign_id, data.item.status)"
            >
              <span class="align-middle">View</span>
            </b-button>
            <!-- <b-button
              v-if="(data.item.status !== '3' && data.item.status!== '1' && (internal==='2' || role==='Telco'))"
              variant="outline-primary"
              size="sm"
              @click="viewDetail(data.item.campaign_id)"
            >
              <span class="align-middle">View</span>
            </b-button>
            <b-button
              v-if="(data.item.status !== '3' && data.item.status=== '1' && internal==='3' && role==='Telco')"
              variant="outline-primary"
              size="sm"
              @click="viewDetail(data.item.campaign_id)"
            >
              <span class="align-middle">View</span>
            </b-button> -->
            <!-- <b-button
              v-if="(data.item.status !== '3' && data.item.status=== '1' && (internal===1 || internal===2))"
              variant="outline-primary"
              size="sm"
              @click="viewDetailApprove(data.item.campaign_id)"
            >
              <span class="align-middle">View</span>
            </b-button> -->
          </template>
        </data-table>
      <!-- </b-card-body> -->
      </b-card>

    </b-col>
  </b-row>
</template>
<script>
import {
  BRow,
  BCol,
  BCard,
  BFormCheckbox,
  BButton,
} from 'bootstrap-vue'
import DataTable from '@/views/component/CheckboxTable.vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BFormCheckbox,
    BButton,
    DataTable,
  },
  data() {
    return {
      table: 'campaign',
      dataFor: 'dataCampaign',
      mutationFor: 'MANAGE',
      list: 'getCampaignManage',
      action: true,
      checkAll: false,
      selected: false,
      internal: this.$store.state.auth.userData.data.departement.id,
      role: this.$store.state.auth.userData.data.Account.role_id,
    }
  },
  computed: {
    ...mapGetters('campaign', {
      dataCampaignField: 'getCampaignManageField',
      dataCampaignItem: 'getCampaignManageItem',
      dataCampaignStatus: 'getCampaignManageStatus',
      getListReason: 'getListReason',
    }),
    ...mapGetters('datas', {
      campaignId: 'getSelectedRow',
    }),
  },
  mounted() {
    if ((this.internal === 2 || this.internal === 3 || this.internal === 5) && this.role === 2) {
      this.action = false
    }
    this.clearTable()
    this.setId()
    this.resetRow()
    // this.getCampaignManage()
    this.dataReasonCampaign()
    this.$store.commit('campaign/SET_MANAGE_SEARCH')
  },
  methods: {
    ...mapActions('campaign', [
      'getCampaignManage',
      'actionCampaign',
      'listReason',
      'clearTable',
    ]),
    ...mapActions('datas', [
      'dataReasonCampaign',
    ]),
    ...mapMutations('campaign', {
      setId: 'SET_CAMPAIGN_ID',
    }),
    ...mapMutations('datas', {
      resetRow: 'setSelectedRow',
    }),
    viewDetail(id, status) {
      this.setId(id)
      const routeName = this.$route.matched[0].path
      console.log(id, status, this.internal, this.role, routeName)
      if (status === '1' && (this.role === 1 || this.role === 2) && (this.internal === 1 || this.internal === 2)) {
        this.$router.push({ path: `${routeName}/approval/${id}` })
      } else {
        this.$router.push({ path: `${routeName}/view/${id}` })
      }
    },
    viewDetailApprove(id) {
      this.setId(id)
      const routeName = this.$route.matched[0].path
      this.$router.push({ path: `${routeName}/approval/${id}` })
    },
    selectAll() {
      if (this.checkAll) {
        this.selected = true
        this.$refs.tableManageCampaign.selectAllRows()
      } else {
        this.selected = false
        this.$refs.tableManageCampaign.clearAllRows()
      }
    },
    formatDateIdr(date) {
      let dd = date.replace(/-/g, '/')
      let d = new Date(dd)
      const dt = (`0${d.getDate()}`).slice(-2)
      const month = (`0${d.getMonth() + 1}`).slice(-2)
      const year = d.getFullYear()
      return `${dt}/${month}/${year}`
    },
    formatPrice(value) {
      if (!this.isFloat(value)) {
        let val = (value / 1).toFixed(0).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      }
      return value
    },
    isFloat(n) {
      return Number(n) === n && n % 1 !== 0
    },
  },
}
</script>

<style scoped>
input[type="checkbox"]:disabled + label::before{
  background: rgb(138, 44, 44);
}
input[type="checkbox"]:disabled + label:hover::before{
  background: rgb(122, 59, 59);
  border: 1px solid #d4d4d5;
}
</style>
